var map = {
	"./58/Kambi/LogoTypes.resource": [
		69206,
		40007
	],
	"./58/Spectate/LogoTypes.resource": [
		33911,
		95786
	],
	"./75/Kambi/LogoTypes.resource": [
		4427,
		23370
	],
	"./75/Spectate/LogoTypes.resource": [
		87378,
		97139
	],
	"./81/Kambi/LogoTypes.resource": [
		97822,
		25397
	],
	"./81/Spectate/LogoTypes.resource": [
		68697,
		51684
	],
	"./87/Spectate/LogoTypes.resource": [
		79857,
		7538
	],
	"./92/Spectate/LogoTypes.resource": [
		71337,
		72340
	],
	"./94/Spectate/LogoTypes.resource": [
		38175,
		96610
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98140;
module.exports = webpackAsyncContext;